// extracted by mini-css-extract-plugin
export var container = "Intro-module--container--931f3";
export var animation = "Intro-module--animation--fded1";
export var layout = "Intro-module--layout--f033c";
export var details = "Intro-module--details--e21c3";
export var detailsTitle = "Intro-module--detailsTitle--0f7ca";
export var detailsDescription = "Intro-module--detailsDescription--bfd71";
export var logo = "Intro-module--logo--bd644";